module.exports = __webpack_public_path__ + "components/weather-icon/static/nightsnowshowers@2-960b1dedd554a89bd526fe8b3fc94c73.png";